(function () {
  var cartDrawerParent = null;
  var cartDrawerNext = null;
  var cartOpen = false;

  var WIDGET_SELECTORS = [
    '#smile-ui-container',
    '[id^="smile-ui"]',
    'iframe[src*="smile.io"]',
    'div[data-floating-ui-portal]',
    '#P0-6[data-floating-ui-portal]',
    '.needsclick.kl-teaser-WwhdZB'
  ];

  var SKIP_BODY_CHILD_IDS = new Set([
    'CartDrawer',
    'x-page-transition',
    'MainContent'
  ]);

  function getCartDrawer() {
    return document.getElementById('CartDrawer');
  }

  function moveCartToBody() {
    var drawer = getCartDrawer();
    if (!drawer || drawer.parentElement === document.body) return;
    cartDrawerParent = drawer.parentElement;
    cartDrawerNext = drawer.nextSibling;
    document.body.appendChild(drawer);
  }

  function restoreCartPosition() {
    var drawer = getCartDrawer();
    if (!drawer || !cartDrawerParent) return;
    if (cartDrawerNext) {
      cartDrawerParent.insertBefore(drawer, cartDrawerNext);
    } else {
      cartDrawerParent.appendChild(drawer);
    }
  }

  function setWidgetHidden(el, hide) {
    if (!el || el.id === 'CartDrawer') return;
    if (hide) {
      el.dataset.lazyLeafCartHidden = '1';
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('opacity', '0', 'important');
    } else if (el.dataset.lazyLeafCartHidden) {
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
      el.style.removeProperty('opacity');
      delete el.dataset.lazyLeafCartHidden;
    }
  }

  function toggleWidgets(hide) {
    WIDGET_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        setWidgetHidden(el, hide);
      });
    });

    Array.from(document.body.children).forEach(function (el) {
      if (!(el instanceof HTMLElement)) return;
      if (SKIP_BODY_CHILD_IDS.has(el.id) || el.classList.contains('main-container')) return;

      var style = window.getComputedStyle(el);
      var zIndex = parseInt(style.zIndex, 10) || 0;
      var isFloatingWidget =
        style.position === 'fixed' &&
        (el.shadowRoot || zIndex >= 9999 || el.querySelector('iframe'));

      if (isFloatingWidget) {
        setWidgetHidden(el, hide);
      }
    });

    if (hide && window.alia && typeof window.alia.close === 'function') {
      try {
        window.alia.close();
      } catch (error) {}
    }
  }

  function onCartStateChange(open) {
    if (open === cartOpen) return;
    cartOpen = open;
    document.body.classList.toggle('cart-drawer-open', open);

    if (open) {
      moveCartToBody();
      toggleWidgets(true);
    } else {
      toggleWidgets(false);
      restoreCartPosition();
    }
  }

  function watchMiniCart() {
    var prevOpen = false;

    function poll() {
      if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
        var open = !!Alpine.store('xMiniCart').open;
        if (open !== prevOpen) {
          prevOpen = open;
          onCartStateChange(open);
        }
      }
      window.requestAnimationFrame(poll);
    }

    poll();
  }

  function init() {
    watchMiniCart();

    new MutationObserver(function () {
      if (!cartOpen) return;
      moveCartToBody();
      toggleWidgets(true);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
